import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString, { ParseOptions } from 'query-string';

export const useSearch = (parseOptions: ParseOptions = {}) => {
  const { search } = useLocation();
  const optionsString = JSON.stringify(parseOptions);

  return useMemo(() => {
    const options = JSON.parse(optionsString);

    return queryString.parse(search, {
      parseBooleans: true,
      ...options,
    });
  }, [search, optionsString]);
};
